import { Component, h, Host, Prop } from '@stencil/core';
import clsx from 'clsx';

@Component({
  tag: 'linear-gradrient',
  styleUrl: 'linear-gradrient.scss',
  shadow: true
})
export class LinearGradrient {
  roundedClasses = {
    'rounded-full': 'rounded-full',
    'rounded-lg': 'rounded-lg',
    'rounded-md': 'rounded-md',
    'rounded-xl': 'rounded-xl',
    'rounded-sm': 'rounded-sm',
    'rounded-none': 'rounded-none'
  };
  @Prop() rounded: string = 'rounded-full';
  @Prop() borderClass: string = 'cards-drop-down-border-gradient';
  render() {
    const classes = clsx(this.roundedClasses[this.rounded], this.borderClass);
    return (
      <Host>
        <div class={classes}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
